<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dEtoJP/Images/cover.jpg?1685327560668" alt="This image is the cover for the book The Shared Harvest"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Shared Harvest
      </h1>
      <p class="bookDescription body article font2">
        <p>Doug Johnston is his brother Paul’s primary caregiver. Though Paul’s disease dictates he shouldn’t live past the age of twenty-five, Paul’s thirtieth birthday is a few months away. The brothers have only had each other since their mother passed away years earlier and their father left shortly after Paul's diagnosis with Becker's muscular dystrophy. Though mostly happy with his life, Doug would love to be in a relationship, but he won’t settle for anyone but the perfect man.</p> <p>Carson Oliver used to be the man everyone recognized and wanted, But when the top-rated DIY program he hosted was canceled in the late 90s, he sought comfort in food… lots of food. While he owns a landscaping business and family farm, he doesn’t think life has much more to offer than working and taking care of his ailing mother. When he meets Doug, the attraction is immediate. It is aided by an important role Carson once played in Doug and Paul's lives—one Carson doesn't remember but they've never forgotten.</p> <p>When Carson doesn’t believe anyone can possibly want him the way he is, Doug sets out to prove him wrong. With the assistance of his enthusiastic brother, Carson’s unrestrained mother, and her crazy cat, Doug just might get the job done.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        D.W. Marchwell
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?35af06da